<!--考生答题界面-->
<template>
	<div style="background-color: #F7F7F7;padding: 10px 0;">
		<b-container class="bv-example-row">
			<el-page-header style="margin-bottom: 10px;" @back="goBack" :content="headerInfo">
			</el-page-header>
			<el-alert v-if="form.type==0" title="友情提示：考试途中不能退出网页，一旦退出成绩出现问题，责任由个人承担。" type="error" :closable="false">
			</el-alert>
			<b-row>
				<b-col sm="3">
					<div class="left-area">
						<div class="left-top">
							<div class="mark-area">
								<div class="mark-shape mark-shape1"></div>
								<div class="mark-label">当前</div>
							</div>
							<div class="mark-area">
								<div class="mark-shape mark-shape2"></div>
								<div class="mark-label">未答</div>
							</div>
							<div class="mark-area">
								<div class="mark-shape mark-shape3"></div>
								<div class="mark-label">已答</div>
							</div>
							<div class="mark-area">
								<div class="mark-shape mark-shape4"></div>
								<div class="mark-label">标记</div>
							</div>
						</div>
						<div class="left-bottom">
							<div style="font-weight: 600;" class="title">{{examData.paperName}}</div>
							<div class="question-area">
								<div @click="change(index)" v-for="(item, index) in topic" :key="index"
									class="question-item"
									:class="{'mark-shape1':currentIndex==index,'mark-shape2':currentIndex!=index&&!item.isAnswer,'mark-shape3':item.isAnswer,'mark-flag':item.flag}">
									{{index+1}}
								</div>
								<div style="width: 30px; height: 0px;margin:0 10px;"></div>
								<div style="width: 30px; height: 0px;margin:0 10px;"></div>
								<div style="width: 30px; height: 0px;margin:0 10px;"></div>
							</div>
						</div>
						<div class="submit-btn">
							<button @click="commit()" type="submit"
								class="main-btn">{{form.type==0?'提交试卷':'保存练习记录'}}</button>
						</div>
					</div>
				</b-col>
				<b-col sm="9">
					<div class="right-area">
						<div class="right-top">
							<div>
								全卷共{{topic.length}}题<span
									v-if="form.type==0">，满分{{parseFloat(examData.totalScore)}}分，及格分{{parseFloat(examData.passingScore)}}分</span>
							</div>
							<div v-if="form.type==0"><i class="el-icon-timer"></i>倒计时：<b>{{countDown}}</b></div>
						</div>
						<div class="right-content">
							<div class="choose-label">{{this.currentIndex+1}}.<span
									v-if="currentQuestion.type==0">【单选题】</span>
								<span v-if="currentQuestion.type==1">【多选题】</span> {{currentQuestion.subjectName}}<span
									v-if="form.type==0"
									style="color: red;">({{parseFloat(currentQuestion.subjectScore)}}分)</span>
							</div>
							<el-radio-group style="display: flex;" v-if="currentQuestion.type==0"
								v-model="form.answer[currentIndex].radio" @change="changeRadio">
								<el-radio v-for="(item,index) in currentQuestion.paperSubjectOptions" :key="index"
									:label="item.baseId">{{item.optionName}}</el-radio>
							</el-radio-group>
							<el-checkbox-group v-if="currentQuestion.type==1" v-model="form.answer[currentIndex].check"
								@change="changeCheck">
								<el-checkbox style="display:block;margin-bottom: 10px;"
									v-for="(item,index) in currentQuestion.paperSubjectOptions" :key="index"
									:label="item.baseId">{{item.optionName}}</el-checkbox>
							</el-checkbox-group>
							<div v-if="form.type==1" style="text-align: center;">
								<el-button @click="judged" type="success" round>确定</el-button>
							</div>
							<div v-if="form.type==1&&form.answer[currentIndex].isAnswer" class="intro-area">
								<div v-if="form.answer[currentIndex].trueOrFalse"
									style="display: flex;align-items: center;">
									<img class="face-icon" src="../../assets/imgs/face1.png" />
									<div style="color: #67C23A;" class="face-name">答对了~</div>
								</div>
								<div v-if="!form.answer[currentIndex].trueOrFalse"
									style="display: flex;align-items: center;">
									<img class="face-icon" src="../../assets/imgs/face2.png" />
									<div style="color: #D81E06;" class="face-name">答错了~</div>
								</div>
								<div style="margin-top: 15px;">
									<div>
										您的答案：<span>{{form.answer[currentIndex].submitAnswer}}</span>
									</div>
									<div style="margin-top: 5px;">
										正确答案：<span
											style="color: #67C23A;">{{form.answer[currentIndex].trueAnswer}}</span>
									</div>
								</div>
								<div style="margin-top: 10px;"><span
										style="font-weight: 600;">答案解析：</span>{{form.answer[currentIndex].analyzes?form.answer[currentIndex].analyzes:'暂无'}}
								</div>
							</div>
						</div>
						<div class="right-operation">
							<div class="arrow" @click="previous()"><i class="el-icon-arrow-left"></i><span>上一题</span>
							</div>
							<div class="flag" style="background: #FF90AA;" v-if="currentQuestion.flag" @click="mark(1)">
								<i class="el-icon-s-flag"></i><span>解标</span>
							</div>
							<div class="flag" v-else @click="mark(2)"><i class="el-icon-s-flag"></i><span>标记</span>
							</div>
							<div class="arrow" @click="next()"><span>下一题</span><i class="el-icon-arrow-right"></i>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
	import {
		genPaper,
		submitPaper,
		answerJudgment
	} from "@/api/lesson";

	export default {
		data() {
			return {
				countDownTime: 600, //设置默认时间,(单位秒)
				timer: null, //计数器名称,便于后面清除
				radio: [], //单选选项
				checkList: {}, //多选选项
				currentIndex: 0, //全局index
				examData: {}, //考试信息
				topic: {}, //所有题目
				currentQuestion: {
					paperSubjectOptions: []
				}, //当前显示题目信息
				form: {
					platformId: undefined,
					paperId: undefined,
					answer: [],
					paperInfoVo: {},
					duration: undefined,
					type: undefined
				},
				judgeForm: {
					subjectId: '',
					answerIds: ''
				},
				headerInfo: ''
			}
		},
		created() {
			this.getExamData()
			this.form.platformId = this.$route.query.lessonId
			this.form.type = this.$route.query.type
			if (this.form.type == 0) {
				this.headerInfo = '课程考试'
			} else {
				this.headerInfo = '课后练习'
			}
		},
		computed: {
			// 计算属性自动计算countDownTime,并转换为倒计时
			countDown() {
				const hour = parseInt(this.countDownTime / 3600) < 10 ? '0' + parseInt(this.countDownTime / 3600) :
					parseInt(this.countDownTime / 3600)
				const min = parseInt(this.countDownTime % 3600 / 60) < 10 ? '0' + parseInt(this.countDownTime % 3600 /
					60) : parseInt(this.countDownTime % 3600 / 60)
				const sec = parseInt(this.countDownTime % 3600 % 60) < 10 ? '0' + parseInt(this.countDownTime % 3600 %
					60) : parseInt(this.countDownTime % 3600 % 60)
				return hour + ':' + min + ':' + sec
			},
		},
		beforeDestroy() { //页面关闭时清除定时器  
			clearInterval(this.timer);
			sessionStorage.removeItem("exam_time");
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			startCountDown() {
				this.timer = setInterval(() => {
					if (this.countDownTime == 0) {
						//当监测到countDownTime为0时,清除计数器并且移除sessionStorage,然后执行提交试卷逻辑
						clearInterval(this.timer);
						sessionStorage.removeItem("exam_time");
						this.$message({
							showClose: true,
							type: 'error',
							message: '考试结束！！！'
						})
						this.submitPaper()
					}
					if (this.countDownTime == 180) {
						this.$message({
							showClose: true,
							type: 'error',
							message: '考生注意,考试时间还剩3分钟！！！'
						})
					}
					if (this.countDownTime > 0) {
						//每秒让countDownTime -1秒,并设置到sessionStorage中
						this.countDownTime--;
						window.sessionStorage.setItem("exam_time", this.countDownTime);
					}
				}, 1000);
			},
			//获取当前试卷所有信息
			getExamData() {
				genPaper(this.$route.query.lessonId, this.$route.query.type).then(res => {
					this.form.paperInfoVo = res.data
					this.examData = res.data //获取考试详情
					this.form.paperId = this.examData.baseId
					if (this.form.type == 0) {
						//初始化时读取sessionStorage中储存的数据,有就设置为countDownTime,没有就根据自己逻辑设置countDownTime
						if (window.sessionStorage.getItem("exam_time") == null) {
							this.countDownTime = this.examData.duration * 60 //获取秒数
							this.startCountDown();
						} else {
							this.countDownTime = Number(window.sessionStorage.getItem("exam_time"));
							this.startCountDown();
						}
					}
					//试题题目信息
					this.topic = this.examData.paperSubjects
					this.topic.map(item => {
						item.flag = false
						item.isAnswer = false
						this.form.answer.push({
							paperSubjectId: item.baseId,
							commitAnswer: "",
							radio: null,
							check: [],
							trueAnswer: null,
							analyzes: null,
							trueOrFalse: null,
							isAnswer: false,
							submitAnswer: ''
						})
					})
					this.currentQuestion = this.topic[0]
				})
			},
			//切换题目
			change(index) {
				this.currentIndex = index
				this.currentQuestion = this.topic[this.currentIndex]
			},
			//多选改变
			changeCheck(e) {
				if (e.length != 0) {
					this.topic[this.currentIndex].isAnswer = true
					this.form.answer[this.currentIndex].commitAnswer = e.toString()
				} else {
					this.topic[this.currentIndex].isAnswer = false
				}
			},
			//单选改变
			changeRadio(val) { //获取选择题作答选项
				this.topic[this.currentIndex].isAnswer = true
				this.form.answer[this.currentIndex].commitAnswer = val
			},
			//判断对错
			judged() {
				this.judgeForm.subjectId = this.currentQuestion.baseId
				this.judgeForm.answerIds = this.form.answer[this.currentIndex].commitAnswer
				answerJudgment(this.judgeForm).then(res => {
					this.form.answer[this.currentIndex].trueOrFalse = res.data.trueOrFalse
					this.form.answer[this.currentIndex].analyzes = res.data.analyzes
					this.form.answer[this.currentIndex].trueAnswer = res.data.trueAnswer
					this.form.answer[this.currentIndex].isAnswer = true
					if (this.currentQuestion.type == 0) {
						this.form.answer[this.currentIndex].submitAnswer = this.currentQuestion.paperSubjectOptions
							.filter(item => item.baseId == this.form.answer[this.currentIndex].commitAnswer)[0]
							.optionName
					} else {
						this.form.answer[this.currentIndex].submitAnswer = ''
						var all = this.currentQuestion.paperSubjectOptions
							.filter(item => this.form.answer[this.currentIndex].commitAnswer.includes(item.baseId))
						all.forEach(item => {
							this.form.answer[this.currentIndex].submitAnswer = this.form.answer[this
								.currentIndex].submitAnswer + item.optionName + '，'
						})
					}
				})
			},
			//上一题
			previous() {
				if (this.currentIndex != 0) {
					this.currentIndex--
					this.change(this.currentIndex)
				}
			},
			//下一题
			next() {
				if (this.currentIndex != this.topic.length - 1) {
					this.currentIndex++
					this.change(this.currentIndex)
				}
			},
			//标记功能
			mark(index) {
				if (index == 1) {
					this.topic[this.currentIndex].flag = false //选择题解标
				} else {
					this.topic[this.currentIndex].flag = true //选择题标记
				}
				this.$forceUpdate()
			},
			//考试提交
			commit() {
				if (this.form.type == 0) {
					if (this.countDownTime != 0) {
						this.$confirm("考试结束时间未到,是否提前交卷", "友情提示", {
							confirmButtonText: '立即交卷',
							cancelButtonText: '再检查一下',
							type: 'warning'
						}).then(() => {
							this.submitPaper()
						}).catch(() => {
							console.log("继续答题")
						})
					}
				} else {
					this.submitPaper()
				}
			},
			submitPaper() {
				this.form.duration = (this.examData.duration * 60) - this.countDownTime
				submitPaper(this.form).then(res => {
					if (res.code == 200) {
						this.$message({
							showClose: true,
							type: 'success',
							message: '提交成功'
						})
						this.$router.push({
							path: "/profile",
							query: {
								type: 4
							}
						})
					} else {
						this.$message({
							showClose: true,
							type: 'error',
							message: res.msg
						})
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.submit-btn {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 15px;
	}

	.left-area {
		.left-top {
			display: flex;
			justify-content: space-around;
			padding: 10px 0px;
			border: 1px solid #eee;
			border-radius: 4px;
			margin: 10px 0;
			background-color: #fff;
			width: 100%;
		}

		.mark-area {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.mark-label {
				margin-top: 5px;
			}

			.mark-shape {
				width: 22px;
				height: 22px;
				border-radius: 50%;
			}
		}

		.mark-shape1 {
			border: 1px solid #FF90AA;
			box-shadow: 0px 0px 5px #FF90AA;
		}

		.mark-shape2 {
			border: 1px solid #eee;
		}

		.mark-shape3 {
			background-color: #547af8;
			border: none;
			color: #fff;
		}

		.mark-shape4 {
			position: relative;
			border: 1px solid #eee;
		}

		.mark-shape4::before {
			width: 4px;
			height: 4px;
			content: " ";
			position: absolute;
			background-color: red;
			border-radius: 50%;
			top: 0px;
			left: 16px;
		}

		.left-bottom {
			border-radius: 4px;
			background-color: #fff;
			width: 100%;
			padding: 12px;

			.title {
				color: #000;
				margin-bottom: 10px;
			}

			.question-area {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				max-height: 380px;
				overflow-y: scroll;

				.question-item {
					width: 30px;
					height: 30px;
					border-radius: 50%;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					margin: 10px;
				}

				.mark-flag {
					position: relative;
				}

				.mark-flag::before {
					width: 4px;
					height: 4px;
					content: " ";
					position: absolute;
					background-color: red;
					border-radius: 50%;
					top: 0px;
					right: 5px;
				}
			}

			.question-area::-webkit-scrollbar {
				width: 5px;
				height: 10%;
			}

			.question-area::-webkit-scrollbar-track {
				background-color: #f1f1f1;
				border-radius: 10px;
			}

			/* 滚动条的滑轨背景颜色 */
			.question-area::-webkit-scrollbar-thumb {
				background-color: #A4A9C1;
				border-radius: 10px;
			}

			.final {
				cursor: pointer;
				display: inline-block;
				text-align: center;
				background-color: #547af8;
				width: 100%;
				border-radius: 4px;
				height: 30px;
				line-height: 30px;
				color: #fff;
				margin-top: 20px;
			}
		}
	}

	.right-area {
		.right-top {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 10px 20px;
			border: 1px solid #eee;
			border-radius: 4px;
			margin: 10px 0;
			background-color: #fff;
			width: 100%;
		}

		.right-content {
			padding: 10px 20px;
			border: 1px solid #eee;
			border-radius: 4px;
			background-color: #fff;
			width: 100%;
			min-height: 500px;

			.choose-label {
				margin-bottom: 15px;
				color: #000;
			}
		}

		.right-content .el-radio-group label {
			color: #000;
			margin: 5px 0px;
		}

		.right-content .el-radio-group {
			display: flex;
			flex-direction: column;
		}

		.right-operation {
			background-color: #fff;
			border: 1px solid #eee;
			border-radius: 4px;
			padding: 10px;
			margin-top: 10px;
			display: flex;
			justify-content: space-around;
			align-items: center;

			.arrow {
				cursor: pointer;
				color: #547af8;
			}

			.flag {
				cursor: pointer;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				background-color: #547af8;
				border-radius: 50%;
				width: 50px;
				height: 50px;
				color: #fff;
			}
		}
	}

	::v-deep .el-radio__label {
		line-height: 28px;
		color: #7F8080;
		white-space: normal;
		/* 换行 */
	}

	::v-deep .el-checkbox__label {
		white-space: normal;
		color: #7F8080;
		/* 换行 */
	}

	.intro-area {
		margin-top: 30px;

		.face-icon {
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}

		.face-name {
			font-weight: 600;
		}
	}
</style>